import React from 'react';

const Marquee = () => {
  return (
    <div className="marquee-wrapper">
      <div className="marquee-container">
        <div className="icon-badge">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="bell-icon">
            <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
          </svg>
        </div>
        <div className="marquee-content">
          <span className="marquee-text">
            <span className="highlight">📢 Important:</span> Share Your Valuable Suggestions to Help Us Improve! 
            <span className="separator">•</span>
            Your Feedback Matters 
            <span className="separator">•</span>
            <a href="https://www.gmail.com" className="marquee-link">Click Here to Submit</a>
            <span className="separator">•</span>
          </span>
          <span className="marquee-text">
            <span className="highlight">📢 Important:</span> Share Your Valuable Suggestions to Help Us Improve! 
            <span className="separator">•</span>
            Your Feedback Matters 
            <span className="separator">•</span>
            <a href="https://www.gmail.com" className="marquee-link">Click Here to Submit</a>
            <span className="separator">•</span>
          </span>
        </div>
      </div>

      <style>{`
        .marquee-wrapper {
          width: 100%;
          position: relative;
          overflow: hidden;
          background: linear-gradient(135deg, #0f156b 0%, #1a237e 50%, #0f156b 100%);
          box-shadow: 0 4px 15px rgba(15, 21, 107, 0.3);
          border-top: 3px solid #ffd700;
          border-bottom: 3px solid #ffd700;
        }

        .marquee-wrapper::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
          animation: shine 3s infinite;
        }

        @keyframes shine {
          0% {
            left: -100%;
          }
          100% {
            left: 100%;
          }
        }

        .marquee-container {
          display: flex;
          align-items: center;
          padding: 12px 0;
          position: relative;
          overflow: hidden;
        }

        .icon-badge {
          position: absolute;
          left: 20px;
          z-index: 10;
          background: linear-gradient(135deg, #ffd700, #ffed4e);
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
          animation: pulse 2s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
          }
          50% {
            transform: scale(1.1);
            box-shadow: 0 6px 20px rgba(255, 215, 0, 0.6);
          }
        }

        .bell-icon {
          width: 24px;
          height: 24px;
          color: #0f156b;
          animation: ring 2s ease-in-out infinite;
        }

        @keyframes ring {
          0%, 100% {
            transform: rotate(0deg);
          }
          10%, 30% {
            transform: rotate(-15deg);
          }
          20%, 40% {
            transform: rotate(15deg);
          }
          50% {
            transform: rotate(0deg);
          }
        }

        .marquee-content {
          display: flex;
          white-space: nowrap;
          animation: scroll 25s linear infinite;
          padding-left: 80px;
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .marquee-text {
          display: inline-flex;
          align-items: center;
          font-size: 16px;
          font-weight: 500;
          color: #ffffff;
          letter-spacing: 0.5px;
          padding-right: 50px;
        }

        .highlight {
          background: linear-gradient(90deg, #ffd700, #ffed4e);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 700;
          margin-right: 10px;
          text-shadow: 0 0 20px rgba(255, 215, 0, 0.5);
        }

        .separator {
          margin: 0 15px;
          color: #ffd700;
          font-size: 20px;
          opacity: 0.7;
        }

        .marquee-link {
          color: #ffd700;
          text-decoration: none;
          font-weight: 700;
          padding: 4px 12px;
          border-radius: 20px;
          background: rgba(255, 215, 0, 0.15);
          border: 1px solid #ffd700;
          transition: all 0.3s ease;
          margin: 0 5px;
        }

        .marquee-link:hover {
          background: #ffd700;
          color: #0f156b;
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
        }

        .marquee-container:hover .marquee-content {
          animation-play-state: paused;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .icon-badge {
            width: 38px;
            height: 38px;
            left: 10px;
          }

          .bell-icon {
            width: 20px;
            height: 20px;
          }

          .marquee-content {
            padding-left: 60px;
          }

          .marquee-text {
            font-size: 14px;
          }

          .separator {
            margin: 0 10px;
            font-size: 16px;
          }

          .marquee-link {
            padding: 3px 10px;
            font-size: 14px;
          }
        }

        @media (max-width: 480px) {
          .marquee-container {
            padding: 10px 0;
          }

          .icon-badge {
            width: 35px;
            height: 35px;
            left: 8px;
          }

          .bell-icon {
            width: 18px;
            height: 18px;
          }

          .marquee-content {
            padding-left: 50px;
          }

          .marquee-text {
            font-size: 13px;
          }

          .separator {
            margin: 0 8px;
            font-size: 14px;
          }

          .marquee-link {
            padding: 2px 8px;
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default Marquee;